module.exports = __webpack_public_path__ + "static/img/fluid-freight-platform_256.fa9e128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fluid-freight-platform_256.png
// module id = f0ZY
// module chunks = 0